import { PaymentAmounts } from 'common/modules/atoms/paymentAmounts';
import { StatusWithVariant } from '../utils';

export type ChargeStatus = 'unpaid' | 'paid' | 'overpaid' | 'refunded' | 'pending_refund';

export const getChargeStatus = (
	paymentAmounts: PaymentAmounts,
): StatusWithVariant<ChargeStatus> => {
	const chargeStatusOrder: StatusWithVariant<ChargeStatus>[] = [
		{ status: 'unpaid', variant: 'danger' },
		{ status: 'pending_refund', variant: 'neutral' },
		{ status: 'paid', variant: 'success' },
		{ status: 'overpaid', variant: 'warning' },
		{ status: 'refunded', variant: 'warning' },
	];
	for (const statusWithColor of chargeStatusOrder) {
		const { status } = statusWithColor;
		if (hasChargeStatus(status, paymentAmounts)) {
			return statusWithColor;
		}
	}
	return { status: 'unpaid', variant: 'danger' };
};

export const hasChargeStatus = (status: ChargeStatus, paymentAmounts: PaymentAmounts) => {
	switch (status) {
		case 'unpaid':
			return paymentAmounts.unpaid > 0;
		case 'paid':
			return paymentAmounts.unpaid === 0;
		case 'overpaid':
			return paymentAmounts.unpaid < 0;
		case 'refunded':
			return paymentAmounts.refunded > 0;
		case 'pending_refund':
			return paymentAmounts.pendingRefunds > 0;
	}
};
